import { createSelector } from "reselect";

import { State } from "common/types/redux";

import { getAllCourses } from "seneca-common/features/course/state";
import { isSignedIn } from "seneca-common/features/user/state";

import {
  getEnrolledCourseIds,
  getFetchCourseEnrollmentsStarted,
  getFetchCourseEnrollmentsSuccess
} from "../state";

const getValidEnrolledCourseDetails = createSelector(
  getAllCourses,
  getEnrolledCourseIds,
  (allCourses, enrolledCourseIds) => {
    return allCourses
      .toList()
      .filter(course => enrolledCourseIds.includes(course.id!));
  }
);

export const getAllCourseEnrollmentsInAlphabeticalOrder = createSelector(
  getValidEnrolledCourseDetails,
  enrolledCourses => {
    return enrolledCourses.sort((a: any, b: any) =>
      a.name.localeCompare(b.name)
    );
  }
);

export const getAllCourseEnrollmentIdsInAlphabeticalOrder = createSelector(
  getAllCourseEnrollmentsInAlphabeticalOrder,
  enrolledCourses => enrolledCourses.map(emt => emt.id)
);

export const courseEnrollmentsNeedFetching = (state: State): boolean =>
  isSignedIn(state) &&
  !(
    getFetchCourseEnrollmentsSuccess(state) ||
    getFetchCourseEnrollmentsStarted(state)
  );
